const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

/** Admin display format: DD MMM YYYY hh:mm A (e.g. 04 Aug 2026 05:22 PM) */
export function formatAdminDateTime(value) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "—";

  const day = String(date.getDate()).padStart(2, "0");
  const month = MONTHS[date.getMonth()];
  const year = date.getFullYear();

  let hours = date.getHours();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours %= 12;
  if (hours === 0) hours = 12;

  const minutes = String(date.getMinutes()).padStart(2, "0");
  const hourStr = String(hours).padStart(2, "0");

  return `${day} ${month} ${year} ${hourStr}:${minutes} ${ampm}`;
}

/** Latest allowed DOB string (YYYY-MM-DD) for minimum age (e.g. 18 → born on/before this date). */
export function getMaxDobForMinAge(minAge = 18) {
  const date = new Date();
  date.setFullYear(date.getFullYear() - minAge);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function isAtLeastMinAge(dobString, minAge = 18) {
  if (!dobString) return false;

  const dob = new Date(`${dobString}T00:00:00`);
  if (Number.isNaN(dob.getTime())) return false;

  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
    age -= 1;
  }

  return age >= minAge;
}
